import React from 'react'
import styled from 'styled-components'
import { ShowTablet } from '../../atoms/ShowTablet'
import { media } from '../../utils/media'
import down from './down.svg'
import up from './up.svg'

interface IProps {
  currentIndex?: number
  count?: number
  goToNext: null | (() => void)
  goToPrev: null | (() => void)
}

export const IntakeProgressBar = ({ currentIndex, count, goToPrev, goToNext }: IProps) => (
  <Container className="no-print">
    <Centered>
    {goToPrev &&
      (currentIndex === undefined || currentIndex !== 0) &&
      <Up onClick={goToPrev}><img src={up} alt="Previous" /><ShowTablet>{process.env.REACT_APP_LANGUAGE === 'es' ? 'Anterior' : 'Previous'}</ShowTablet></Up>}
      {currentIndex !== undefined && count !== undefined ? (
        <BarBg>
          <BarFg style={{ width: `${(currentIndex + 1) / count * 100}%` }}/>
          <BarContainer>
            <BarTitle>{currentIndex + 1}/{count}</BarTitle>
          </BarContainer>
        </BarBg>
      ) : <NoBar />}
      {goToNext && <Down onClick={goToNext}><img src={down} alt="Next" /><ShowTablet>{process.env.REACT_APP_LANGUAGE === 'es' ? 'Proximo' : 'Next'}</ShowTablet></Down>}
    </Centered>
  </Container>
)

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;

  background: #ffffff;
  box-shadow: 0 -2px 10px 0 #00000003;
`

const Centered = styled.div`
  max-width: 920px;
  display: flex;
  align-items: center;
  margin: 0 auto;
`

const Up = styled.button`
  display: flex;
  align-items: center;
  padding: 16px ;
  appearance: none;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 600;
  color: #5498A0;
  text-align: left;

  ${media.tablet`
    width: 160px;
    margin-right: 60px;
    img { margin-right: 12px; }
  `}
`

const BarBg = styled.div`
  flex: 1 0 auto;
  background: #DDEBED;
  height: 20px;
  border-radius: 10px;
  position: relative;
  text-align: center;
`

const BarFg = styled.div`
  background: #FC9426;
  position: absolute;
  height: 20px;
  border-radius: 10px;
`

const BarContainer = styled.div`
  display: flex;
  height: 20px;
  align-items: center;
  justify-content: center
`

const BarTitle = styled.div`
  font-family: "SF Pro Display";
  font-size: 10px;
  font-weight: 600;
  color: #1C4B77;
  position: relative;
  align-self: center;
`

const NoBar = styled.div`
  flex: 1 0 auto;
`

const Down = styled(Up)`
  text-align: right;

  ${media.tablet`
    margin-right: 0;
    margin-left: 60px;
  `}
`



// WEBPACK FOOTER //
// ./src/molecules/IntakeProgressBar/index.tsx